// extracted by mini-css-extract-plugin
module.exports = {"additional-title":"DeleteTaskModal_additional-title__3Lh6B"};